const routers = [
    {
        path: '/personal_center/service_provider',
        name: 'service_provider',
        meta: {
            exp: '服务商',
            requireAuth: true
        },
        redirect:"/personal_center/service_provider/service_provider_info",
        component: () => import('@/views/personal_center/service_provider/index.vue'),
        children: [
            {
                path:'/personal_center/service_provider/service_provider_info',
                name:'service_provider_info',
                meta:{
                    exp:'园区信息',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/service_provider/user_info/index.vue'),
            },
            {
                path: '/personal_center/service_provider/service_provider_order',
                name: 'service_provider_order',
                meta: {
                    exp: '我的订单',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/service_provider/my_order/index.vue'),
            },
            {
                path: '/personal_center/service_provider/my_evaluation',
                name: 'my_evaluation',
                meta: {
                    exp: '我的评价',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/service_provider/my_evaluation/index.vue'),
            },
            {
                path: '/personal_center/service_provider/store_info',
                name: 'store_info',
                meta: {
                    exp: '店铺信息',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/service_provider/store_info/index.vue'),
            },
            {
                path: '/personal_center/service_provider/my_service',
                name: 'my_service',
                meta: {
                    exp: '我的服务',
                    requireAuth: true
                },
                redirect: '/personal_center/service_provider/my_service/list',
                component: () => import('@/views/personal_center/service_provider/my_service/index.vue'),
                children: [
                    {
                        path: '/personal_center/service_provider/my_service/list',
                        name: 'my_service_list',
                        meta: {
                            exp: '我的服务',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/service_provider/my_service/list/index.vue'),
                    },
                    {
                        path: '/personal_center/service_provider/my_service/edit',
                        name: 'my_service_edit',
                        meta: {
                            exp: '我的服务',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/service_provider/my_service/edit/index.vue'),
                    },
                    {
                        path: '/personal_center/service_provider/my_service/detail',
                        name: 'my_service_detail',
                        meta: {
                            exp: '我的服务',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/service_provider/my_service/detail/index.vue'),
                    },
                ]
            },
            {
                path: '/personal_center/service_provider/settled_in',
                name: 'settled_in',
                meta: {
                    exp: '入驻成为服务商',
                    requireAuth: true
                },
                redirect: '/personal_center/service_provider/settled_in/list',
                component: () => import('@/views/personal_center/service_provider/settled_in/index.vue'),
                children: [
                    {
                        path: '/personal_center/service_provider/settled_in/list',
                        name: 'service_provider_settled_in_list',
                        meta: {
                            exp: '入驻成为服务商',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/service_provider/settled_in/certificaiton_table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/service_provider/settled_in/detail',
                        name: 'service_provider_settled_in_detail',
                        meta: {
                            exp: '入驻成为服务商',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/service_provider/settled_in/certification_details/index.vue'),
                    },
                    {
                        path: '/personal_center/service_provider/settled_in/from',
                        name: 'service_provider_settled_in_from',
                        meta: {
                            exp: '入驻成为服务商',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/service_provider/settled_in/certification_from/index.vue'),
                    },
                ]
            },
            {
                path: '/personal_center/service_provider/switchCampus',
                name: 'switchCampus',
                meta: {
                    exp: '切换园区',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/service_provider/switchCampus/index.vue'),
            },
        ]
    },
]
export default routers
